import tw from 'tailwind-styled-components';
import styled from 'styled-components';

export const Container = styled.div`
  padding-top: 50px;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  justify-content: center;
  @media (min-width: 768px) {
    .trigger-action {
      &:hover,
      &:focus {
        .hidden-until-hover-or-focus-on-desktop {
          max-height: 0px;
          opacity: 1;
          transition: all 1.4s ease-in-out;
        }
        .shift {
          top: -25px;
          transition: all 0.4s ease-in-out;
          @media (min-width: 768px) and (max-width: 1023px) {
            transition: all 0.4s ease-in-out;
          }
        }
      }
    }
  }
`;
Container.displayName = 'Container';

export const BoxWrapper = styled.div`
  position: relative;
  display: grid;
  justify-items: center;
`;
export const BoxContainer = styled.div`
  position: absolute;
`;

export const ContactInfo = styled.div`
  border: 1px solid #bbc4ba;
  border-top-left-radius: 100em 25em;
  border-top-right-radius: 100em 25em;
  border-bottom-left-radius: 5em;
  border-bottom-right-radius: 5em;
  text-align: center;
  display: grid;
  justify-items: center;
  width: 100%;
  height: 231px;
`;
ContactInfo.displayName = 'ContactInfo';

export const Icon = styled.div`
  position: relative;
  top: -25px;
  margin-bottom: auto;
  color: #bbc4ba;
  background-color: white;
  border: 1px solid #bbc4ba;
  border-radius: 10rem;
  padding: 10px;
  box-shadow: 0 0 0 5px #fff;
`;
Icon.displayName = 'Icon';

export const TextContainer = styled.div`
  position: relative;
  top: 5px;
  @media (max-width: 768px) {
    top: 0px;
  }
`;
TextContainer.displayName = 'TextContainer';

export const Title = tw.h3`
  text-lg
  lg:text-2xl
`;
Title.displayName = 'Title';

export const FieldWrapper = tw.div`
  p-2
`;
FieldWrapper.displayName = 'FieldWrapper';

export const Field = tw.div`
  p-1
  md:p-2
  text-gray-500
  text-base
  lg:text-lg
  flex
`;
Field.displayName = 'Field';

export const Label = tw.div`
  pr-2
  font-medium
`;
Label.displayName = 'Label';

export const Text = styled.div`
  margin-top: -1px;
`;
Text.displayName = 'Text';

export const HiddenUntilHoverOrFocus = styled.div`
  @media (min-width: 768px) {
    max-height: 0;
    opacity: 0;
    padding-bottom: 0;
  }
`;
HiddenUntilHoverOrFocus.displayName = 'HiddenUntilHoverOrFocus';

export const LinkContents = tw.div`
  pb-5
  flex
  justify-center
`;
LinkContents.displayName = 'LinkContents';

export const LinkLabel = tw.div`
  pr-1
`;
LinkLabel.displayName = 'LinkLabel';

export const CallToAction = styled.div`
  padding-top: 20px;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 16px;
  a {
    color: black;
  }
  span {
    display: initial;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    font-size: 14px;
  }
  @media (min-width: 768px) and (max-width: 1439px) {
    padding-top: 10px;
  }
`;
CallToAction.displayName = 'CallToAction';
